
if( !window.proficient ) {
  window.proficient = {}
}

if( !window.proficient.models ) {
  window.proficient.models = {}
}

class Reservation {
  /**
   * @param { Product } product
   * @param { Product | null } backup
   * @param { number } startDate
   * @param { number } rentPlanDurationInDays
   * @param { string } discountCode
   * @param { string } _id
   * @param { hasPendingBackup } hasPendingBackup
   */

  constructor(
    product,
    backup,
    startDate,
    rentPlanDurationInDays,
    discountCode,
    _id,
    hasPendingBackup = false
  ) {

    this.product = product
    this.backup = backup
    this.startDate = startDate
    this.rentPlanDurationInDays = rentPlanDurationInDays
    this.discountCode = discountCode
    this._id = _id
    this.hasPendingBackup = hasPendingBackup
  }
}

/**
 * @description this class uses localStorage as DB 
 */
class ReservationDB {
  
  reservations = []
  name = 'reservations'

  constructor() {
    this.reservations = this.getReservations()
    this.name = 'reservations'
  }

  /**
   * this load all the reservations from localStorage
   * @returns { Reservation[] }
   */
  getReservations() {
    let reservations = localStorage.getItem(this.name)

    if( !reservations ) {
      localStorage.setItem(this.name, '[]')
      return []
    }

    reservations = JSON.parse(reservations)

    return [ ...reservations ]
  }

  /**
   * adds a new reservation on localStorage
   * @param { Reservation } reservation 
   * @returns { void }
   */
  addReservation(reservation) {
    const { product, startDate, rentPlanDurationInDays } = reservation
    
    if( [product, startDate, rentPlanDurationInDays].some( (value) => !value) ) {
      throw new Error('New reservation to add is invalid')
    }

    const prev = this.getReservations()
    this.reservations = [...prev, reservation ]

    this.save(this.reservations)
  }

  save( reservations ) {
    if( !reservations instanceof Array ) {
      throw new Error('Reservations must to be a instance of Array')
    }

    localStorage.setItem(this.name, JSON.stringify(reservations))
  }

  /**
   * 
   * @returns Reservation | undefined
   */
  getFirstReservationPending() {
    const reservations = this.getReservations()
    const pending = reservations.find( (reservation) => reservation.hasPendingBackup === true )
    return pending || null
  }

  /**
   * This method update a reservation pending.
   * If there isn't any reservation pending
   * return null
   * 
   * @param { Product } backup
   */
  updateBackupPending(backup, discountCode = '', _id = '') {
    const pending = this.getFirstReservationPending()
    if( !pending ) return null

    const index = this.reservations.findIndex( ( reservation => {
      return reservation.product.id === pending.product.id
    }))

    if( index === -1 ) return null

    /**
     * @type { Reservation }
     */
    const reservation = this.reservations[index]

    if( backup ) {
      reservation.backup = backup
    }

    if( discountCode ) {
      reservation.discountCode = discountCode
    }

    if( _id ) {
      reservation._id = _id
    }

    reservation.hasPendingBackup = false

    if( Number(backup.price) > pending.product.price ) {
      const product = { ...pending.product }
      reservation.product = backup
      reservation.backup = product
    }

    this.save( this.reservations )
  }

  clearDB() {
    this.reservations = []
    this.save(this.reservations)
  }


  /**
   * this function returns all the available
   * discounts codes
   * 
   * @returns { string[] } list of available discount codes
   */
  getDiscountsCode() {

    return this.reservations.reduce( (acc, reservation) => {
      const discountCode = reservation.discountCode
      
      if( typeof discountCode === 'string' && discountCode !== '' ) {
        acc.push(discountCode)
      }

      return acc
    }, [])
  }

  /**
   * removes a reservation by its product.variantId or backupId.variantId 
   * @param { string } variantId
   * @return { Reservation | null }
   */
  deleteReservation(variantId = '' ) {
    if( variantId === '' ) {
      throw new Error('variantId passed as argument is empty')
    }

    const reservationToDelete = this.reservations.find( reservation => {
      if (reservation.product.variantId === variantId ) return true

      if( reservation.backup !== null ) {
        if( reservation.backup.variantId === variantId ) return true
      }

      return false
    })

    if( !reservationToDelete ) return null
    
    this.save(this.reservations.filter( res => res.product.id !== reservationToDelete.product.id) )
    return reservationToDelete
  }

  /**
   * this delete a reservation by its mongoId
   * @returns { Reservation | null }
   * 
   */
  deleteReservationByMongoId(_id){
    if( !_id ) {
      throw new Error('_id param is mandatory')
    }

    const reservationToDelete = this.reservations.find( reservation => reservation._id === _id )
    
    if( !reservationToDelete ) return null

    this.save( this.reservations.filter( res => res._id !== reservationToDelete._id ) )
    return reservationToDelete
  }
}

window.proficient.models = { Reservation, ReservationDB }

// abstract classes
class Product {
  /**
   * @abstract
   * @param { number } id
   * @param { number } variantId
   * @param { string } title
   * @param { string } handle
   * @param { number } price
   */
  constructor(
    id,
    variantId,
    title,
    handle,
    price
  ) {
    this.id = id
    this.variantId = variantId
    this.title = title
    this.handle = handle
    this.price = price
  }
}
